<script setup>
defineProps({
  value: {
    type: String,
  },
});
</script>

<template>
  <label class="block text-sm font-medium text-slate-700 dark:text-slate-300">
    <span v-if="value">{{ value }}</span>
    <span v-else><slot /></span>
  </label>
</template>
